import configuration from '../../constants/Configuration';
import previewCommands from '../utils/PreviewCommands';
import platformDetection from '../utils/PlatformDetection';
import { showVideoEditor, refreshVideoEditor, changeClipartCategory } from '../../actions/MenuActions';
import { changeSlideDuration, changeVideoProperties, updateVideoShape } from '../../actions/CurrentSlideActions';
import storeManager from '../../store/StoreManager';
import saveManager from '../utils/SaveManager';
import { updateCurrentSlide, addSplittedSlide } from '../../actions/ProductionActions';
import hoverManager from './HoverManager';
import audioVolumeUtils from './AudioVolumeUtils';
import playController from './PlayController';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import shapeConstants from '../../constants/ShapeConstants';

const videoUtils = {
    dispatch: undefined,
    changeVideoBackground: false,
    loadedVideo: undefined,
    cacheBreaker: '?cacheBreaker=' + Math.random(),

    checkCacheBreaker(url, isVideo = false) {
        if (isVideo)
            return url;

        if (url && url.indexOf('file/ci') != -1 && url.indexOf('/aaa') != -1 && url.indexOf('/aaa?') == -1)
            return url + this.cacheBreaker;
        else
            return url;
    },
    init(dispatch) {
        this.dispatch = dispatch;

        var video = document.getElementById('videoBackground');

        if (!video)
            return;

        video.ondurationchange = this.onVideoLoaded.bind(this);

        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background && background.isVideo)
            this.updateVideoSrc(background);
    },
    onVideoLoaded() {
        if (previewCommands.isPlayMode())
            return;

        this.updateVideoPreloader(false);

        if (!this.changeVideoBackground)
            return;

        var video = document.getElementById('videoBackground');
        var duration = video.duration;

        if (duration > 0) {
            this.dispatch(changeSlideDuration(duration));
            this.changeToVideoEditorMode(video.currentSrc);
            hoverManager.hide();
        }

        this.changeVideoBackground = false;

        if (this.executeAutoPlay && this.executeAction)
            setTimeout(this.autoPlayVideo.bind(this), 100);

        this.refreshVideoEditor();

        this.executeAutoPlay = false;
        this.loadedVideo = video.src;
    },
    changeToVideoEditorMode(currentSrc) {
        this.prepareMultipleVideos(false);
        this.dispatch(showVideoEditor(true));

        if (currentSrc && currentSrc.indexOf('file/ci') != -1)
            return;

        this.dispatch(changeClipartCategory(1));
    },
    autoPlayVideo() {
        if (this.executeAction)
            this.executeAction('play');

        if (this.updateMarkerVisbility)
            this.updateMarkerVisbility(true);
    },
    updateVideoSrc(shapeModel) {
        if (this.isMultipleVideo())
            this.updateCurrentVideo();

        var video = document.getElementById('videoBackground');

        if (!video)
            return;

        if (!shapeModel || !shapeModel.xlinkHref) {
            video.src = undefined;
            return;
        }

        var videoUrl = '';
        var hostName = '';

        if (!configuration.LOAD_LOCAL && shapeModel.xlinkHref.indexOf('http') == -1) {
            if (configuration.IS_PROD())
                hostName = 'https://www.creaza.com';
            else
                hostName = 'https://stage.creaza.com';
        }

        if (shapeModel.isVideo)
            videoUrl = hostName + shapeModel.xlinkHref;

        videoUrl = this.getCorrectUrl(videoUrl);

        if (video.src != videoUrl) {
            if (videoUrl.length > 0) {
                this.updateVideoPreloader(true);
                video.src = this.checkCacheBreaker(videoUrl, true);

                if (!platformDetection.isEdge())
                    video.load();

                if (!this.showVideoEditor()) {
                    this.updateStartPoint();

                    setTimeout(function() {
                        if (this.executeAction)
                            this.executeAction('focus');
                    }.bind(this), 1000);
                } else {
                    if (this.executeAction)
                        this.executeAction('clear');
                }
            } else
                video.src = "";
        }
    },
    refreshVideoEditor() {
        if (this.showVideoEditor()) {
            this.isEditorInitialized = false;
            this.markerPosition = -1;

            this.dispatch(refreshVideoEditor(Math.random()));

            var marker = document.getElementById('marker');

            if (marker)
                marker.style.left = '0px';

            this.updateStartPoint();
        }
    },
    updateVideoPreloader(isVisible = false) {
        var preloader = document.getElementById('videoPreloader');

        if (!preloader || playController.isAudioEditorMode())
            return;

        if (isVisible)
            preloader.style.display = 'block';
        else
            preloader.style.display = 'none';
    },
    getBackgroundVideoVolume() {
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background && background.isVideo && background.volume >= 0)
            return background.volume;
        else
            return 0.5;
    },
    playVideoPreview(playOffset = 0) {
        this.clearTimer();

        var video = document.getElementById('videoBackground');
        var audio = document.getElementById('recordedAudio');

        if (platformDetection.isIOS())
            audioVolumeUtils.changeVolume('videoBackground', this.getVolume());
        else
            video.volume = this.getVolume();

        if (playOffset == 0)
            video.currentTime = this.getStartPoint();

        if (audio && audio.duration > video.currentTime)
            audio.currentTime = video.currentTime;

        this.playTimer = setTimeout(this.onPreviewVideoEnded.bind(this), this.getCurrentSlideDuration() * 1000 - playOffset);

        video.play();

        this.playPauseVideoShapes(true, playOffset === 0);
    },
    getCurrentSlideDuration() {
        const state = storeManager.getState();
        const time = state.currentSlide.model.time;

        return time;
    },
    onPreviewVideoEnded() {
        if (this.isEditorInitialized)
            return;

        if (this.updatePlayButtonHandler)
            this.updatePlayButtonHandler(false, true);

        this.pauseVideoPreview(true);
    },
    pauseVideoPreview(resetTime = false) {
        this.clearTimer();

        var video = this.getCurrentVideo();

        if (!video)
            return;

        video.pause();

        if (resetTime)
            video.currentTime = 0;

        this.playPauseVideoShapes(false, resetTime);
    },
    getPlayOffset() {
        var video = this.getCurrentVideo();

        if (!video)
            return 0;

        var startPoint = this.getStartPoint();

        if (video.currentTime > startPoint)
            return (video.currentTime - startPoint) * 1000;
        else
            return 0;
    },

    /****************** Video shapes functionality **********************************************/
    isVideoShapes() {
        return videoUtils.getMaxDurationFromVideoShapes() > 0;
    },
    playPauseVideoShapes(play, resetTime = false, offset = 0) {
        if (videoUtils.isVideoShapes()) {
            const shapes = storeManager.getState().currentSlide.model.content;

            for (var i=1; i<shapes.length; ++i) {
                if (shapes[i].type === shapeConstants.VIDEO) {
                    let videoShape = document.getElementById('videoShape_' + shapes[i].uuid);

                    if (videoShape) {
                        if (play) {
                            videoShape.play();

                            if (resetTime)
                                videoShape.currentTime = 0;
                            else {
                                if (offset > 0)
                                    videoShape.currentTime = offset;
                            }
                        } else {
                            videoShape.pause();

                            if (resetTime)
                                videoShape.currentTime = 0;
                            else {
                                if (offset > 0)
                                    videoShape.currentTime = offset;
                            }
                        }

                        this.dispatch(updateVideoShape(shapes[i].uuid));
                    }
                }
            }
        }
    },
    playVideoShapesPreview(resetTime  = false) {
        this.clearTimer();

        const mainVideo = this.getMainVideoShape();

        if (!mainVideo)
            return;

        var audio = document.getElementById('recordedAudio');

        if (audio && audio.duration > mainVideo.currentTime)
            audio.currentTime = mainVideo.currentTime;

        let playOffset = resetTime ? 0 : mainVideo.currentTime * 1000;

        this.playTimer = setTimeout(this.onPreviewVideoShapeEnded.bind(this), this.getCurrentSlideDuration() * 1000 - playOffset);

        this.playPauseVideoShapes(true, resetTime);
    },
    onPreviewVideoShapeEnded() {
        if (this.isEditorInitialized)
            return;

        if (this.updatePlayButtonHandler)
            this.updatePlayButtonHandler(false, true);

        this.pauseVideoShapesPreview(true);
    },
    pauseVideoShapesPreview(resetTime = false) {
        this.clearTimer();

        this.playPauseVideoShapes(false, resetTime);
    },
    getMainVideoShape() {
        const mainVideoShape = this.getMaxDurationFromVideoShapes(true);

        if (mainVideoShape) {
            const video = document.getElementById('videoShape_' + mainVideoShape.uuid);

            return video;
        } else
            return undefined;
    },
    getMaxDurationFromVideoShapes(getMaxDurationVideoShape = false) {
        const shapes = storeManager.getState().currentSlide.model.content;
        let maxDuration = 0;
        let videoShape;

        for (var i=1; i<shapes.length; ++i) {
            if (shapes[i].type === shapeConstants.VIDEO && shapes[i].duration > 0) {
                if (shapes[i].duration > maxDuration) {
                    maxDuration = shapes[i].duration;
                    videoShape = shapes[i];
                }
            }
        }

        if (getMaxDurationVideoShape)
            return videoShape;
        else
            return maxDuration;
    },
    checkSlideDurationWhenAddVideoShape(duration) {
        // the order for deciding the slide duration for a slide is: video, shape video with the long duration, recorded sound and media/effect sound
        if (this.isVideoBackground())
            return;

        const maxDurationFromVideos = this.getMaxDurationFromVideoShapes();

        if (duration > maxDurationFromVideos)
            this.dispatch(changeSlideDuration(duration));
    },
    /****************** EDITOR functionality ***************/
    currentVideoVolume: 0,
    currentTotalDuration: -1,
    initialVideoVolume: -1,
    initialLeftMarkerPosition: -1,
    initialRightMarkerPosition: -1,
    leftMarkerPosition: -1,
    rightMarkerPosition: -1,
    markerPosition: -1,
    trackWidth: -1,
    isEditorInitialized: false,
    playTimer: undefined,
    videoEndedCallback: undefined,
    browserActiveButton: 0,
    updatePlayButtonHandler: undefined,
    playRegular: undefined,
    markerUpdateHandler: undefined,
    updateMarkerVisbility: undefined,
    executeAction: undefined,
    executeAutoPlay: false,
    currentSlideModel: undefined,

    updateContentFromCurrentSlide() {
        this.currentSlideModel = storeManager.getState().currentSlide.model;
    },
    getInitialProperties(trackWidth) {
        if (this.isEditorInitialized && trackWidth == this.trackWidth)
            return;

        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background && background.isVideo) {
            if (this.isEditorInitialized && trackWidth > 0 && this.trackWidth > 0 && trackWidth != this.trackWidth) {
                this.leftMarkerPosition = this.leftMarkerPosition * trackWidth / this.trackWidth;
                this.rightMarkerPosition = this.rightMarkerPosition * trackWidth / this.trackWidth;
                this.markerPosition = this.markerPosition * trackWidth / this.trackWidth;

                this.initialLeftMarkerPosition = this.leftMarkerPosition;
                this.initialRightMarkerPosition = this.rightMarkerPosition;

                this.trackWidth = trackWidth;
            } else {
                this.trackWidth = trackWidth;
                this.currentTotalDuration = this.getVideoTotalDuration();
                this.currentVideoVolume = this.getBackgroundVideoVolume();
                this.initialVideoVolume = this.currentVideoVolume;

                if (background.inPoint >= 0)
                    this.leftMarkerPosition = (this.trackWidth * background.inPoint) / this.currentTotalDuration;
                else
                    this.leftMarkerPosition = 0;

                this.initialLeftMarkerPosition = this.leftMarkerPosition;

                if (background.outPoint >= 0)
                    this.rightMarkerPosition = (this.trackWidth * background.outPoint) / this.currentTotalDuration;
                else
                    this.rightMarkerPosition = this.trackWidth;

                this.initialRightMarkerPosition = this.rightMarkerPosition;
                this.markerPosition = this.leftMarkerPosition;
            }
        }

        this.isEditorInitialized = true;

        this.pauseVideoPreview();

        if (!this.isVideoBackground() && this.isVideoShapes())
            this.pauseVideoShapesPreview();

        setTimeout(this.checkStartPoint.bind(this), 2);
    },
    checkStartPoint() {
        this.updateStartPoint();
    },
    resetCurrentProperties(updateStartPoint = true) {
        this.clearTimer();
        this.pauseBackgroundVideo();
        this.currentVideoVolume = 0.5;
        this.isEditorInitialized = false;
        this.markerPosition = -1;
        this.initialLeftMarkerPosition = -1;
        this.initialRightMarkerPosition = -1;
        this.leftMarkerPosition = -1;
        this.rightMarkerPosition = -1;

        if (updateStartPoint)
            setTimeout(this.updateStartPoint.bind(this), 500);
    },
    updateNewVideoProperties() {
        var slideModelDuration = this.getCurrentSlideDuration();
        var inPoint = this.getRealTimeInSeconds(this.leftMarkerPosition);
        var outPoint = this.getRealTimeInSeconds(this.rightMarkerPosition);
        var slideDuration = outPoint - inPoint;

        if (this.currentVideoVolume != this.initialVideoVolume || this.leftMarkerPosition != this.initialLeftMarkerPosition || this.rightMarkerPosition != this.initialRightMarkerPosition || slideModelDuration != slideDuration) {
            saveManager.isContentChanged(true);

            var videoProps = {};

            videoProps.volume = this.currentVideoVolume;
            videoProps.inPoint = inPoint;
            videoProps.outPoint = outPoint;

            this.dispatch(changeVideoProperties('all', videoProps));
            this.dispatch(changeSlideDuration(outPoint - inPoint));
        }
    },
    getVideoTotalDuration() {
        var video = document.getElementById('videoBackground');

        return video.duration.toFixed(3);
    },
    getEditVideoDuration() {
        var video = document.getElementById('videoBackground');
        var currentTime = this.rightMarkerPosition - this.leftMarkerPosition;
        var time;

        if (currentTime > 0)
            time = (this.currentTotalDuration * currentTime / this.trackWidth);
        else
            time = video.duration;

        time = parseFloat(time.toFixed(2));

        return this.convertTimeToStringFormat(time);
    },
    convertTimeToStringFormat(time) {
        time = parseFloat(time.toFixed(2));

        var text = '';
        var seconds = Math.floor(time);
        var miliseconds = Math.floor((time - seconds) * 100);
        var minutes = Math.floor(seconds / 60);
        seconds = seconds - minutes * 60;

        if (minutes < 10)
            text = text + '0' + minutes + ':';
        else
            text = text + minutes + ':';

        if (seconds < 10)
            text = text + '0' + seconds + ':';
        else
            text = text + seconds + ':';

        if (miliseconds < 10)
            text = text + '0' + miliseconds;
        else
            text = text + miliseconds;

        return text;
    },
    getTimeInSeconds(position) {
        var time = (position * this.currentTotalDuration) / this.trackWidth;
        return  parseFloat(time.toFixed(1));
    },
    getRealTimeInSeconds(position) {
        var time = (position * this.currentTotalDuration) / this.trackWidth;
        var fixedTime = parseFloat(time.toFixed(3));

        if (fixedTime >= 0)
            return  fixedTime;
        else
            return 0;
    },
    trackOffset() {
        return this.trackWidth / this.currentTotalDuration;
    },
    playBackgroundVideo() {
        this.clearTimer();

        var video = document.getElementById('videoBackground');

        if (platformDetection.isIOS())
            audioVolumeUtils.changeVolume('videoBackground', this.getVolume());
        else
            video.volume = this.getVolume();

        video.currentTime = this.getCurrentPoint();

        var duration = this.getOutPoint() - this.getCurrentPoint();
        this.playTimer = setTimeout(this.onVideoEnded.bind(this), duration * 1000);

        video.play();

        if (this.markerUpdateHandler)
            this.markerUpdateHandler();
    },
    pauseBackgroundVideo(isEnd = false) {
        this.clearTimer();

        var video = document.getElementById('videoBackground');
        video.pause();

        if (this.markerUpdateHandler)
            this.markerUpdateHandler(false, isEnd);
    },
    onVideoEnded() {
        if (!this.isEditorInitialized)
            return;

        if (this.videoEndedCallback)
            this.videoEndedCallback();

        this.markerPosition = this.leftMarkerPosition;
        this.pauseBackgroundVideo(true);

        if (this.isEditorInitialized) {
            var video = document.getElementById('videoBackground');
            this.updateStartPoint();
        }
    },
    clearTimer() {
        if (this.playTimer)
            clearTimeout(this.playTimer);
    },
    getVolume() {
        var volume;

        if (this.isEditorInitialized)
            volume = this.currentVideoVolume;
        else
            volume = this.getBackgroundVideoVolume();

        if (volume >= 0 && volume <= 1)
            return volume;
        else
            return 0.5;
    },
    getStartPoint(index = -1) {
        var start;
        const state = storeManager.getState();
        var background;

        if (index == -1)
            background = state.currentSlide.model.content[0];
        else
            background = state.production.slides[index].content[0];

        if (this.isEditorInitialized)
            start = this.getRealTimeInSeconds(this.leftMarkerPosition);
        else
            start = background.inPoint;

        if (!start)
            start = 0;

        return parseFloat(start);
    },
    getCurrentPoint() {
        var currentPoint;

        if (this.markerPosition >= this.leftMarkerPosition && this.markerPosition <= this.rightMarkerPosition)
            currentPoint = this.getRealTimeInSeconds(this.markerPosition);
        else
            currentPoint = this.getStartPoint();

        if (!currentPoint || isNaN(currentPoint))
            return 0;
        else
            return currentPoint;
    },
    getOutPoint() {
        var end;
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (this.isEditorInitialized)
            end = this.getRealTimeInSeconds(this.rightMarkerPosition);
        else
            end = background.outPoint;

        if (!end)
            end = 0;

        return parseFloat(end);
    },
    updateStartPoint( isOutPoint = false, stop = false) {
        var video = document.getElementById('videoBackground');

        if (video) {
            if (isOutPoint)
                video.currentTime = this.getOutPoint();
            else {
                if (stop)
                    video.pause();

                video.currentTime = this.getStartPoint();
            }
        }

        if (this.updateMarkerVisbility)
            this.updateMarkerVisbility();
    },
    isVideoBackground(slideModel) {
        const state = storeManager.getState();

        if (!slideModel)
            slideModel = state.currentSlide.model;

        if (!slideModel || !slideModel.content)
            return false;

        const background = slideModel.content[0];

        if (background && background.isVideo)
            return true;
        else
            return false;
    },

    /********************************* MARKER functionality ************************/
    updateMarkerPosition(position) {
        if (position < this.leftMarkerPosition)
            position = this.leftMarkerPosition;

        if (position > this.rightMarkerPosition)
            position = this.rightMarkerPosition;

        this.markerPosition = position;

        var video = document.getElementById('videoBackground');
        video.currentTime = this.getRealTimeInSeconds(this.markerPosition);
    },
    getMarkerPosition() {
        if (this.markerPosition < this.leftMarkerPosition)
            return this.leftMarkerPosition;

        if (this.markerPosition > this.rightMarkerPosition)
            return this.rightMarkerPosition;

        return this.markerPosition;
    },
    showVideoEditor() {
        const state = storeManager.getState();

        if (state.menu.showVideoEditor)
            return true;
        else
            return false;
    },
    splitClip() {
        this.currentSlideModel = undefined;

        var inPoint = this.getRealTimeInSeconds(this.leftMarkerPosition);
        var outPoint = this.getRealTimeInSeconds(this.rightMarkerPosition);
        var markerPoint = this.getCurrentPoint();
        var firstSlideDuration = markerPoint - inPoint;
        var secondSlideDuration = outPoint - markerPoint;

        if (firstSlideDuration > 1.0 && secondSlideDuration > 1.0) {
            saveManager.isContentChanged(true);

            this.addNewSlide(markerPoint, outPoint);

            var videoProps = {};

            videoProps.volume = this.currentVideoVolume;
            videoProps.inPoint = inPoint;
            videoProps.outPoint = markerPoint;

            this.dispatch(changeVideoProperties('all', videoProps));
            this.dispatch(changeSlideDuration(firstSlideDuration));

            this.dispatch(updateCurrentSlide());

            if (this.executeAction)
                this.executeAction('reset');
        }
    },
    addNewSlide(inPoint, outPoint) {
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        let newContent = {};
        newContent.logicalName = background.logicalName;
        newContent.href = background.xlinkHref;
        newContent.moods = [];
        newContent.hotSpot = '';
        newContent.frameLabel = '';

        newContent.isVideo = true;
        newContent.volume = this.currentVideoVolume;
        newContent.inPoint = inPoint;
        newContent.outPoint = outPoint;

        if (background.contentItemId > 0)
            newContent.contentItemId = background.contentItemId;

        const currentIndex = state.currentSlide.currentSlideIndex;
        this.dispatch(addSplittedSlide(currentIndex + 1, newContent));

        audioEditorUtils.addActionToHistory();
        saveManager.isContentChanged(true);
    },
    getBackgroundVideo() {
        const state = storeManager.getState();
        const background = state.currentSlide.model.content[0];

        if (background && background.isVideo && background.xlinkHref)
            return background.xlinkHref;
        else
            return '';
    },

    refreshItemRenderer: undefined,

    /******************* Player controller ***************************/
    getCurrentVideo(index = -1) {
        var video;

        if (this.isMultipleVideo()) {
            if (index == -1)
                index = storeManager.getState().currentSlide.currentSlideIndex;

            video = document.getElementById('video_' + index);
        } else
            video = document.getElementById('videoBackground');

        return video;
    },
    getHostName() {
        if (configuration.IS_PROD())
            return 'https://www.creaza.com';
        else
            return 'https://stage.creaza.com';
    },
    getCorrectUrl(url) {
        var newUrl = '';

        if (url && url.indexOf('file/ci') != -1) {
            if (url.indexOf('www.creaza') == -1 && url.indexOf('stage.creaza') == -1)
                newUrl = this.getHostName();

            newUrl = newUrl + url;
        } else {
            newUrl = url;
        }

        return newUrl;
    },
    getSlideVideoModel(model) {
        if (model == undefined)
            model = storeManager.getState().currentSlide.model;

        var videoModel;

        if (!model)
            return videoModel;

        const background = model.content[0];

        if (background.isVideo && background.xlinkHref && background.xlinkHref.length > 0) {
            videoModel = {};

            videoModel.href = this.getCorrectUrl(background.xlinkHref);

            if (background.inPoint == undefined)
                videoModel.inPoint = 0;
            else
                videoModel.inPoint = background.inPoint;

            if (background.outPoint == undefined)
                videoModel.outPoint = 0;
            else
                videoModel.outPoint = background.outPoint;

            if (background.volume == undefined)
                videoModel.volume = 0.5;
            else
                videoModel.volume = background.volume;
        }

        return videoModel;
    },
    playMultipleVideosSequence(index, volume, startTime, play = false) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        var i;
        var previousVideo;
        var currentVideo;

        for (i=0; i<slides.length; i++) {
            var videoElement = document.getElementById('video_' + i);

            if (!videoElement)
                continue;

            if (i == index) {
                if (!(startTime >= 0))
                    startTime = 0;

                if (videoElement.currentTime != startTime)
                    videoElement.currentTime = startTime;

                currentVideo = videoElement;

                if (play) {
                    videoElement.volume = volume;
                    videoElement.play();
                } else
                    videoElement.pause();
            } else {
                videoElement.pause();

                if (videoElement.style.display == 'block')
                    previousVideo = videoElement;
                else
                    videoElement.style.display = 'none';
            }
        }

        if (currentVideo)
            currentVideo.style.display = 'block';

        if (platformDetection.isIOS()) {
            if (previousVideo) {
                setTimeout(function (videoElem) {
                    if (videoElem)
                        videoElem.style.display = 'none';
                }.bind(this), 250, previousVideo);
            }
        } else {
            if (previousVideo)
                previousVideo.style.display = 'none';
        }
    },
    playVideoFromSlideIndex(index, playOffset = 0, play = true) {
        var startTime = this.getStartPoint(index);

        if (playOffset > 0)
            startTime = startTime + playOffset;

        this.playMultipleVideosSequence(index, this.getVolume(), startTime, play);

        if (this.isVideoShapes())
            this.playPauseVideoShapes(play, playOffset === 0); // TODO consider video shape inpoint when introduce video editor
    },
    prepareVideo(videoModel, offset = 0, play = true, forceMute = false, index = -1) {
        if (this.isVideoShapes()) {
            //TODO when introduce inPoint should update it for all video shapes
            if (play)
                this.playPauseVideoShapes(true, false, offset);
            else
                this.playPauseVideoShapes(false, false, offset);
        }

        var video = this.getCurrentVideo(index);
        var isPlayMode = this.isMultipleVideo();

        if (!videoModel) {
            if (!isPlayMode)
                video.src = undefined;

            return;
        }

        if (!video)
            return;

        var videoVolume;

        if (forceMute)
            videoVolume = 0;
        else
            videoVolume = videoModel.volume;

        if (isPlayMode) { // PLAYER, PREVIEW or ADVANCED AUDIO EDITOR mode
            this.playMultipleVideosSequence(index, videoVolume, videoModel.inPoint + offset, play);
        } else { // EDITOR mode
            video.volume = videoVolume;

            if (video.src && video.src != videoModel.href)
                video.src = this.checkCacheBreaker(videoModel.href, true);

            video.currentTime = videoModel.inPoint + offset;

            if (play)
                video.play();
        }
    },
    goToStartPosition() {
        var video = this.getCurrentVideo();

        if (video)
            video.currentTime = this.getStartPoint();

        if (this.isVideoShapes())
            this.playPauseVideoShapes(false, true); //TODO consider inpoint for the video shapes when introduce video editor
    },
    goToPosition(position) {
        var video = this.getCurrentVideo();

        if (video)
            video.currentTime = position;
    },
    /******************* Multiple videos ***************************/
    isMultipleVideo() {
        return previewCommands.isPlayMode() || playController.isAudioEditorMode();
    },
    getSlideVideoHref(index) {
        const state = storeManager.getState();
        const slides = state.production.slides;
        const background = slides[index].content[0];

        if (background.isVideo && background.xlinkHref && background.xlinkHref.length > 0) {
            if (background.xlinkHref.indexOf('http') == -1 && background.xlinkHref.indexOf('file/ci') != -1)
                return this.getVideoPrefix(background.xlinkHref) + background.xlinkHref;
            else
                return background.xlinkHref;
        } else
            return '';
    },
    getVideoPrefix(url) {
        if (url.indexOf('http') == -1) {
            if (configuration.IS_PROD())
                return 'https://www.creaza.com';
            else
                return 'https://stage.creaza.com';
        } else
            return '';
    },
    getMultipleVideosList() {
        const state = storeManager.getState();
        const slides = state.production.slides;
        var i;
        var videos = [];


        for (i=0; i<slides.length; i++)
            videos.push(this.getSlideVideoHref(i));

        return videos;
    },
    videoList: [],
    prepareMultipleVideos(startModule = true) {
        var videoWrapper = document.getElementById('multipleVideos');

        if (videoWrapper)
            videoWrapper.innerHTML = '';

        var oldVideo = document.getElementById('videoBackground');
        this.videoList = [];

        if (startModule) {
            if (oldVideo)
                oldVideo.style.display = 'none';
        } else {
            if (oldVideo)
                oldVideo.style.display = 'block';

            return;
        }

        this.updateVideos();
        this.setInPoints();
    },
    updateCurrentVideo() {
        const state = storeManager.getState();
        const slides = state.production.slides;
        const currentIndex = state.currentSlide.currentSlideIndex;
        var i;

        for (i=0; i<slides.length; i++) {
            var video = document.getElementById('video_' + i);

            if (video) {
                if (i == currentIndex) {
                    video.style.display = 'block';
                    video.currentTime = this.getStartPoint(i);
                } else
                    video.style.display = 'none';
            }
        }
    },
    updateVideos() {
        var videoWrapper = document.getElementById('multipleVideos');

        if (!videoWrapper)
            return;

        videoWrapper.innerHTML = '';

        var slidesVideos = this.getMultipleVideosList();
        var i;
        const currentIndex = storeManager.getState().currentSlide.currentSlideIndex;
        var videoHolder = document.createElement('div');

        videoWrapper.appendChild(videoHolder);

        for (i=0; i<slidesVideos.length; i++) {
            var videoHref = slidesVideos[i];
            var videoElement;

            if (videoHref != '') {
                videoElement = document.createElement('VIDEO');
                videoElement.id = 'video_' + i;
                videoElement.style.position = 'absolute';
                videoElement.style.top = '0px';
                videoElement.style.left = '0px';
                videoElement.style.width = '800px';
                videoElement.style.height = '450px';
                videoElement.className = 'audioItem';
                videoElement.preload = 'auto';
                videoElement.playsinline = true;
                videoElement.src = this.checkCacheBreaker(this.getCorrectUrl(videoHref), true);

                if (i != currentIndex)
                    videoElement.style.display = 'none';

                videoHolder.appendChild(videoElement);
            }
        }

        this.videoList = slidesVideos;
    },
    checkVideoList() {
        var currentList = this.getMultipleVideosList();
        var oldList = this.videoList;
        var i;
        var updateVideoSequence = false;

        if (currentList.length == oldList.length) {
            for (i = 0; i < currentList.length; i++) {
                if (currentList[i] != oldList[i]) {
                    updateVideoSequence = true;
                    break;
                }
            }
        } else
            updateVideoSequence = true;

        if (updateVideoSequence)
            this.updateVideos();
    },
    setInPoints() {
        const state = storeManager.getState();
        const slides = state.production.slides;

        for (var i=0; i<slides.length; i++) {
            var video = document.getElementById('video_' + i);

            if (!video)
                continue;

            if (platformDetection.isIOS()) {
                try {
                    video.play();

                    setTimeout(function (videoElement, index) {
                        videoElement.pause();
                        videoElement.currentTime = this.getStartPoint(index);
                    }.bind(this), 20, video, i);
                } catch (e) {
                    // error
                }
            } else {
                video.currentTime = this.getStartPoint(i);
            }
        }
    },
    refreshVideosInPlayMode(excludedVideo = -1) {
        setTimeout(function() {
            if (previewCommands.isPlayMode()) {
                const state = storeManager.getState();
                const slides = state.production.slides;
                var i;

                for (i = 0; i < slides.length; i++) {
                    var videoElement = document.getElementById('video_' + i);

                    if (!videoElement || i == excludedVideo)
                        continue;

                    var startTime = this.getStartPoint(i);

                    if (videoElement.currentTime != startTime)
                        videoElement.currentTime = startTime;

                    videoElement.pause();

                    if (i == state.currentSlide.currentSlideIndex)
                        videoElement.style.display = 'block';
                    else
                        videoElement.style.display = 'none';
                }
            }
        }.bind(this), 20);
    }
};

export default videoUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/VideoUtils.js
 **/